var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1542_16360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1542_16360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 64,
    height: 64,
    fill: "#2A4169"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1542_16360",
    transform: "scale(0.00390625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1542_16360",
    width: 256,
    height: 256,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.79783d79edd51ded88c4c534836be6d8.svg";
export { ForwardRef as ReactComponent };